import { useTranslation } from "react-i18next";
import React, { useEffect, useRef, useState } from 'react';
import { LuHeart, LuShare2, LuLoaderCircle } from 'react-icons/lu';
import { useEngagement, useFavorite } from '../context/EngagementContext';
import { engagementApi } from '../Services/engagementService';
import { shareListing } from '../Services/shareService';
import { toast } from 'react-toastify';
export default function EngagementActions({kind,listing,showShare=true,iconOnly=false}) {
  const { t } = useTranslation();
  const {user} = useEngagement();
  const {isFavorite,toggleFavorite,favoriteLoading} = useFavorite(kind,listing);
  const [busy,setBusy] = useState(false); const lock=useRef(false);
  const [saving, setSaving] = useState(false);
  const favoriteLock = useRef(false);
  async function toggle() {
    if (favoriteLock.current) return;
    favoriteLock.current = true;
    setSaving(true);
    try { await toggleFavorite(); }
    finally { favoriteLock.current = false; setSaving(false); }
  }
  const id=listing.id || listing.ID;
  useEffect(()=> { if(user && id) engagementApi.view(kind,id).catch(e=>toast.error(e.message)); },[kind,id,user]);
  async function share() {
    if(lock.current) return; lock.current=true; setBusy(true);
    try { const message=await shareListing(kind,listing); if(message) toast.success(message); }
    catch(e) { if(e.name!=='AbortError') toast.error(t("ui.unable_to_share_the_link_please_try_again")); }
    finally { lock.current=false; setBusy(false); }
  }
  return <div className="flex flex-wrap items-center gap-2">
    <button type="button" className={iconOnly ? "listing-photo-action" : "lina-action"} disabled={favoriteLoading || saving}
      aria-busy={saving} aria-pressed={isFavorite}
      aria-label={t(isFavorite ? 'remove_from_favorites' : 'add_to_favorites')}
      title={t(isFavorite ? 'remove_from_favorites' : 'add_to_favorites')} onClick={toggle}>
      {saving ? <LuLoaderCircle aria-hidden="true" className="animate-spin" size={18}/> : <LuHeart aria-hidden="true" size={18} className={isFavorite ? 'text-rose-600' : ''} fill={isFavorite ? 'currentColor' : 'none'}/>}
      {!iconOnly && t(saving ? 'saving' : isFavorite ? 'in_my_favorites' : 'add_to_favorites')}
    </button>
    {showShare && <button type="button" className="lina-action" disabled={busy} aria-busy={busy} onClick={share}>
      {busy ? <LuLoaderCircle aria-hidden="true" size={18} className="animate-spin"/> : <LuShare2 aria-hidden="true" size={18}/>}
      {t(busy ? 'preparing' : 'share')}
    </button>}
  </div>;
}
